export const calendarDayOfWeek_Friday = "PINKD";
export default {calendarDayOfWeek_Friday};